export default {
    export: 'تصدير',
    'export-as-excel': 'تصدير إكسل',
    'print-accounts-tree': 'طباعة شجرة الحسابات',
    'account-num-or-name': 'رقم أو اسم الحساب',
    add: 'إضافة',
    'please-select-account' : 'يرجى اختيار حساب',
    'number-of-main-accounts': 'عدد الحسابات الأساسية:',
    'number-of-sub-accounts': 'عدد الحسابات الفرعية:',
}